import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext(null);

const FALLBACK = {
  phone: "",
  whatsapp: "",
  email: "info@nidaandentalcare.co.in",
  address_line1: "",
  address_line2: "",
  city: "",
  state: "",
  pincode: "",
  hours_weekday: "",
  hours_weekend: "",
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(FALLBACK);

  const refresh = async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch {
      /* keep fallback */
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, setSettings, refresh }}>{children}</SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);

export function formatAddress(s) {
  return [s.address_line1, s.address_line2, [s.city, s.state].filter(Boolean).join(", "), s.pincode]
    .filter(Boolean)
    .join(", ");
}
